import HttpService from "./HttpService";
const axios 			= HttpService.getAxiosClient();
const methods 		= HttpService.HttpMethods;
const baseURL 		= process.env.REACT_APP_BACKEND_URL;
const rootRequestMapping = 'sweepJob'

async function getAllSweepJobs() {
    let language = localStorage.getItem("language");
    try {
        let res = await axios.request({
            url: `${baseURL}${rootRequestMapping}/all/${language}`,
            method: methods.GET
        });

        return (res.status === 200) ? res.data : false;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}
async function signOffSweepJob(id, invert){
    try {
		
        let res = await axios.request({
            url: `${baseURL}${rootRequestMapping}/signoff/${id}/${invert}`,
            method: methods.GET
        });

        return (res.status === 200) ;
    }
    catch (error) {
        console.error(error);
        return false;
    }
}


async function getSweepJobById(id){
    let language = localStorage.getItem("language");
    try {
        let res = await axios.request({
            url: `${baseURL}${rootRequestMapping}/${id}/${language}`,
            method: methods.GET
        });

        return (res.status === 200) ? res.data : false;
    }
    catch (error) {
        console.error(error);
        return false;
    }
}



async function addJob(data) {
    let language = localStorage.getItem("language");
    try {
        if(data.state == null)  data.state = "Received";
        if (data.jobChanged) delete data.jobChanged
        let res = await axios.request({
            url: `${baseURL}${rootRequestMapping}/${language}`,
            method: methods.POST,
            data: data,
        });

        return (res.status === 200) ? res.data : false;
    }
    catch (error) {
        console.error(error);
        return false;
    }
}

const savejobPage1 = async (data) => {
    let language = localStorage.getItem("language");
    try {
        let res = await axios.request({
            url: `${baseURL}${rootRequestMapping}/savepageone/${language}`,
            method: methods.POST,
            data: data
        });

        return res.data;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}

const savejobPage2 = async (data, id) => {
    let language = localStorage.getItem("language");
    try {
        let res = await axios.request({
            url: `${baseURL}${rootRequestMapping}/savepagetwo/${id}/${language}`,
            method: methods.POST,
            data: data
        });

        return res.data;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}




export {
    addJob, savejobPage1, getAllSweepJobs, getSweepJobById, savejobPage2, signOffSweepJob
};